import React, { Component } from 'react';
import { request } from 'http';
import Q from './shared/Q'
import MySlider from './shared/MySlider'

export default class Head extends Component {
	state={value:5}
	onAns(value) {
		this.setState({value})
	}
	render() {
		const {t,l} = this.props
		const {value} = this.state
		return <Q q="When you hear about a new app that sounds good, how easy it’s for you to download and install it?" {...this.props}>
			<div style={{
				position:"absolute",
				top:200,
				left:20,
				color:"grey"
			}}>
				<p> 1 - very easy </p>
				<p> 10 - very difficult </p>
			</div>
			<MySlider style={{
				position:"absolute",
				top:300,
				left:60
			}} value={value} min={1} max={10} cb={value => this.setState({value})}/>

		</Q>	
	}
}



// WEBPACK FOOTER //
// ./src/dComp/EasyDownloadNewApps.js